module.exports = __webpack_public_path__ + "img/vip.9b2276f9.png";